import { Box, Flex, Text, Card, Heading, DataList, Button, Badge, IconButton, Avatar } from '@radix-ui/themes';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import SchoolSearch from '../../schoolSearch/SchoolSearch';
import { Cross2Icon, Pencil1Icon, TrashIcon } from '@radix-ui/react-icons';
import { studentAccountService } from '../../../services/student/studentAccountService';
import { toast } from 'react-toastify';
import { updateStudentAccount, updateStudentSchool } from '../../../redux/slices/studentAccountSlice';

const StudentSchoolProfile = () => {
    const user = useSelector((state) => state.user.details);
    const account = useSelector((state) => state.studentAccount);
    const [selectedSchoolId, setSelectedSchoolId] = useState(null);
    const [editing, setEditing] = useState(false);

    const dispatch = useDispatch();

    const handleSchoolSelect = async (schoolId) => {
        if (!schoolId) {
            return;
        }
        try {
            console.log('setting school', schoolId);
            const response = await studentAccountService.setSchool(schoolId);
            console.log('school', response);
            dispatch(updateStudentSchool(response.school));
            setEditing(false);
            toast.success('School set successfully');
        } catch (error) {
            console.error('Error setting school', error);
            toast.error('Error setting school');
        }
    }

    const handleClearSchool = async () => {
        try {
            await studentAccountService.clearSchool();
            setEditing(false);
            toast.success('School cleared successfully');
            dispatch(updateStudentSchool(null));
        } catch (error) {
            console.error('Error clearing school', error);
            toast.error('Error clearing school');
        }
    }

    return (
            <Flex direction="column" gap="4" width="100%">
                <Flex direction="row" justify="between" align="center">
                    <Heading size="2">School Information</Heading>
                    <Button variant="ghost" onClick={() => setEditing(!editing)}> <Pencil1Icon /> {editing ? 'Cancel' : 'Edit'}</Button>
                </Flex>


                {editing ? (
                    <Flex direction="column" gap="4" mt="1">
                        <SchoolSearch
                            onSelect={handleSchoolSelect}
                        />
                    </Flex>
                ) : (
                    <Flex direction="column" gap="4" align="start" width="100%">
                        {account.school ? (
                            <>
                            <Flex direction="row" justify="between" gap="3" align="center" width="100%">
                            {account.school.crest != '' ? <Avatar size="3"
                                src={`${import.meta.env.VITE_PUBLIC_URL}/storage/${account.school.crest}`}
                                fallback={<Avatar
                                    size="3"
                                    src={'/images/defaultCrest.png'}

                                />}
                            /> : <Avatar size="3"
                                src={'/images/defaultCrest.png'}
                            />}
                            <Box align="start" style={{ flex: 1 }}>
                                <Text as="p" size="1" weight="bold" color="var(--gray-12)">{account.school.name}</Text>
                                <Text as="p" size="1">{account.school.location}</Text>
                            </Box>
                        </Flex>
                            </>
                        ) : (
                            <Box align="start">
                                <Text size="2">You should add your school to your profile. This will help us to personalize your experience.</Text>
                                <Text size="2">If you school is not listed, please contact your administrator.</Text>
                            </Box>
                        )}
                        <Button
                            onClick={handleClearSchool}
                            variant="ghost" color="red" size="1" radius="full">
                            <TrashIcon />Clear School
                        </Button>
                    </Flex>
                )}
            </Flex>
    );
};

export default StudentSchoolProfile;
